export default __webpack_public_path__ + "cf53ddc686a1e0b70d7549484a124afe.woff";